import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { BookButton } from "./BookButton";
import { scrollToSection, scrollToTop } from "@/lib/scroll";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "glass border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <nav className="container flex h-[72px] items-center justify-between">
        <Logo onClick={scrollToTop} />

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-slate-300 transition-colors hover:text-cyan-300"
            >
              {l.label}
            </button>
          ))}
          <BookButton testid="nav-cta-book" className="px-5 py-2.5" />
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-slate-200 md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="glass border-b border-white/5 px-6 pb-6 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={() => go(l.href)}
                className="rounded-lg px-3 py-3 text-left text-base font-medium text-slate-200 transition-colors hover:bg-white/5 hover:text-cyan-300"
              >
                {l.label}
              </button>
            ))}
            <BookButton
              testid="nav-mobile-cta-book"
              className="mt-3 w-full"
            />
          </div>
        </div>
      )}
    </header>
  );
}
